export default __webpack_public_path__ + "static/media/zodiacToto-Boar.a4d15486.png";